import { child, get, DatabaseReference } from 'firebase/database'
import { GoalData, IGoalData } from '../data/GoalData'

const spreadsheetID: string = process.env.REACT_APP_SPREADSHEET_ID!

export function getGoals(dbRef: DatabaseReference): Promise<GoalData[]> {
    return get(child(dbRef, spreadsheetID)).then((snapshot) => {
        if (snapshot.exists() && 'Goals' in snapshot.val()) {
            try {
                let data: IGoalData[] = snapshot.val()['Goals']
                return data.map((d) => new GoalData(d))
            } catch (e) {
                console.error('Data failed to parse\n', e)
                return []
            }
        } else {
            console.error('No data available')
            return []
        }
    })
}
